/* global $ Image */
import * as SpriteSpin from 'spritespin'
$('.spritespin').each(function (index) {
  var img = new Image()
  img.onload = function (spin) {
    var ratio = this.width / this.height
    var width = (this.width > 500) ? 500 : this.width
    var height = width / ratio
    $(spin).spritespin({
      source: SpriteSpin.sourceArray($(spin).data('source') + '/{frame}.jpg', { frame: [0, $(spin).data('nbitems') - 1], digits: 2 }),
      width: width,
      sense: -1,
      height: height
    })
    $(spin).ready(function () {
      $(spin).spritespin('api').stopAnimation()
      $(spin).spritespin('api').data.reverse = !$(spin).data.reverse
    })
  }.bind(img, this)
  img.src = $(this).data('source') + '/00.jpg'
})

$('.niquelesysteme').mouseover(function () {
  var spin = $(this).parent().parent().find('.spritespin')
  var api = spin.spritespin('api')

  api.playTo(11)
  api.data.reverse = !api.data.reverse

  $(this).parent().parent().find('.projectThumbnailXPHover').fadeIn(300)
  $(this).parent().parent().find('.projectThumbnailXPHover').find('h4').css('opacity', '0').delay(100).animate({top: '-83px', opacity: 1}, 500)
  $(this).parent().parent().find('.projectThumbnailXPHover').find('h5').css('opacity', '0').delay(100).animate({left: '65px', opacity: 1}, 400)
})

$('.niquelesysteme').mouseleave(function () {
  var spin = $(this).parent().parent().find('.spritespin')
  var api = spin.spritespin('api')
  api.data.reverse = !api.data.reverse
  api.playTo(0)
  $(this).parent().parent().find('.projectThumbnailXPHover').fadeOut(200)
  $(this).parent().parent().find('.projectThumbnailXPHover').find('h4').animate({top: '-93px', opacity: 0}, 0)
  $(this).parent().parent().find('.projectThumbnailXPHover').find('h5').animate({left: '100px', opacity: 0}, 200)
})

$('#lien-interactif').css('fill', '#FFF')
$(document).ready(function () { $(document).scrollTop(0) })

var windowHeight = $(window).height()
var xph = $('.xp-texte').height()
var xph2 = $('.xp-texte2').height()

$('.xp-texte').css('top', (windowHeight - xph - 20) / 2 + 'px')
$('.xp-texte2').css('top', (windowHeight - xph2 - 20) / 2 + 'px')
$('#projets').css('padding-top', (windowHeight - 130) / 2 + 'px')

$('.xp-texte').click(function () {
  var st = $(window).scrollTop()
  $('html, body').animate({ scrollTop: st + 250 }, { duration: 1000 })
})
